import { cn } from "@repo/utils";
import type { DialogBaseProps } from "../dialog.types.js";

export const DialogHeader = ({ className, children }: DialogBaseProps) => {
  return (
    <div className={cn("mb-4 flex flex-col space-y-1.5 text-left", className)}>{children}</div>
  );
};
